import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Button, Container, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import { Colors } from "../theme";

export const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: Colors.border, 
    },
    "&:hover fieldset": {
      borderColor:Colors.border,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.border, 
    },
  },
});

export const StyledContainer = styled(Container)({
  marginTop: "2rem",
  '& .ticket-history-box': {
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "16px",
  },
  '& .resource-list': {
    paddingRight: "-10px",
  },
  '& .custom-card': {
    borderBottom: '1px solid'+Colors.primary, // Red bottom border
    boxShadow: '0px 0.0001px 0.5px'+ Colors.primary, // Red shadow
    '&:hover': {
      boxShadow: '0px 1px 2px '+ Colors.primary, // Darker shadow on hover
    },
  },
  '& .color': {
    color: Colors.primary,
  },
  '& .underline': {
    textDecoration: "underline",
  },
  '& .subtitle1': {
    fontSize: "1.04rem",
    position: "center",
    marginBottom: "3rem",
    textAlign: 'center',
  },
  '& .section_title': {
  },
});

export const StyledLink = styled(Link)({
  textDecoration: "underline",
  color: Colors.primary,
  fontWeight: "bold",
});

export const SectionTitle = styled(Typography)({
  color: Colors.primary,
  marginBottom: "1.5rem", // Matches `mb={6}`
  '& .left': {
    textAlign: "left",
  },
  '&.center': {
    textAlign: "center",
  },
});

export const StyledButton = styled(Button)(({ disabled }) => ({
  backgroundColor: disabled ? Colors.hover : Colors.primary,
  color: Colors.white,
}));

export const DialogTitleStyled = styled(DialogTitle)({
  textAlign: "center",
  fontSize: 30,
  color: Colors.primary,
  paddingBottom: "10px", // Reduced padding
});

// New component for compact dialog content
export const CompactDialogContent = styled(DialogContent)({
  padding: "0px 24px 10px", // Reduced padding
  overflowY: "hidden", // Prevent scrolling
});

// New container for success message content
export const SuccessMessageContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px", // Add small gap between elements
});

export const CheckIconStyled = styled(CheckCircleIcon)({
  fontSize: 60, // Reduced size from 80px to 60px
  color: Colors.primary,
  marginBottom: "0", // Removed bottom margin
});

export const AccordionTitle = styled(Typography)({
  color: Colors.primary,
});

export const IconWrapper = styled(Box)({
  color: Colors.primary,
  fontSize: "large",
  display: "flex", // Use flexbox for centering
  justifyContent: "center", // Center horizontally
  alignItems: "center", // Center vertically
  height: "50px", // Reduced height from 100px to 50px
});

export const ContactCard = styled(Box)({
  marginTop: "0.5rem", // Reduced margin from 1rem to 0.5rem
  textAlign: "center",
});

export const FormWrapper = styled(Box)({
  marginTop: "2rem", // Matches `mt={2}`
  marginBottom: "2rem", // Matches `mb={8}`
  '& .request-box': {
    display: "flex",
    justifyContent: "flex-end" // Matches `mt={2}`
  },
});

export const TicketMessage = styled(Typography)({
  marginTop: "0", // Reduced from 1rem to 0
  fontSize: "18px", // Slightly reduced from 20px
  textAlign: "center",
});